import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { PersonSelect } from './PersonSelect';
import { RecipientTag } from './RecipientTag';

interface AdditionalPeopleProps {
  value: string[];
  dropdownValue: string;
  onDropdownValueChange: (value: string) => void;
  onAdd: (name: string) => void;
  onRemove: (index: number) => void;
  people: string[];
  portalContainer: HTMLDivElement | null;
  onOpenChange: (open: boolean) => void;
}

export const AdditionalPeople: React.FC<AdditionalPeopleProps> = ({
  value,
  dropdownValue,
  onDropdownValueChange,
  onAdd,
  onRemove,
  people,
  portalContainer,
  onOpenChange
}) => {
  // Handle recipient tag click
  const handleRecipientClick = (index: number) => {
    onRemove(index);
  };

  return (
    <Accordion type="single" collapsible className="w-full mb-2">
      <AccordionItem value="optional-people">
        <AccordionTrigger className="text-sm dark:text-gray-200">
          Additional People (Optional)
        </AccordionTrigger>
        <AccordionContent className="px-2">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4">
            <div>
              <PersonSelect
                value={dropdownValue}
                onValueChange={onDropdownValueChange}
                portalContainer={portalContainer}
                onEnterPress={onAdd}
                waitForEnter={false}
                people={people}
                label="Add Person"
                isOptional={true}
                onOpenChange={onOpenChange}
                showConfirmButton={true}
              />
            </div>
            
            <div>
              <label className="text-sm font-medium dark:text-gray-200 block mb-2">
                Selected Recipients:
              </label>
              <div className="flex flex-wrap gap-1 p-2 border rounded-md dark:border-gray-600 min-h-[60px]">
                {value.length > 0 ? (
                  value.map((name, index) => (
                    <RecipientTag 
                      key={index} 
                      name={name} 
                      onRemove={() => handleRecipientClick(index)} 
                    />
                  ))
                ) : (
                  <span className="text-sm text-gray-500 dark:text-gray-400">
                    No additional recipients selected
                  </span>
                )}
              </div>
            </div>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default AdditionalPeople;